export const getOrganizationsFromState = (state) => {
  const { organizations } = state;
  return { organizations };
};

export const getCustomerOrganization = (state) => {
  const { customerOrg } = state;
  return { customerOrg };
};
